import {
  ApacCandidateFooter,
  ApacCandidateHeaderFooterLinkProvider,
} from '@seek/apac-candidate-header-footer';
import { Box, Divider } from 'braid-design-system';

import { useAuthenticationStatus } from 'src/context/use-user';

export const Footer = ({ lean = false }) => {
  const authenticationStatus = useAuthenticationStatus();

  return (
    <ApacCandidateHeaderFooterLinkProvider value={{ sendLinkEvent: () => {} }}>
      <Box position="relative" zIndex={1}>
        <Divider />
      </Box>
      <ApacCandidateFooter
        authenticationStatus={authenticationStatus}
        showCountryList={false}
        widthMode="large"
        isExpandedVersion={!lean}
      />
    </ApacCandidateHeaderFooterLinkProvider>
  );
};
